export const blazons = [
    {
        id: 'Blazon1',
        preview: 'Erb-A-01.svg',
    },
    {
        id: 'Blazon2',
        preview: 'Erb-A-02.svg',
    },
    {
        id: 'Blazon3',
        preview: 'Erb-A-03.svg',
    },
];
